export default __webpack_public_path__ + "b68397d2e8d39ad3a337f087bb753c41.png";